import { API_BASE } from '../config';

export const MENTIONABLE_ENTITIES_CHANGED_EVENT = 'mentionable-entities-changed';

export function dispatchMentionableEntitiesChanged(projectId: string | undefined): void {
  if (!projectId || projectId === 'new') {
    return;
  }
  window.dispatchEvent(
    new CustomEvent(MENTIONABLE_ENTITIES_CHANGED_EVENT, { detail: { projectId } }),
  );
}

export async function dispatchMentionableEntitiesChangedForDocument(
  documentId: string | undefined,
  token: string | null,
  masterKey: string | null,
  knownProjectId?: string | null,
): Promise<void> {
  if (knownProjectId && knownProjectId !== 'new') {
    dispatchMentionableEntitiesChanged(knownProjectId);
    return;
  }
  if (!documentId) {
    return;
  }
  const url = masterKey
    ? `${API_BASE}/api/documents/${documentId}?masterKey=${encodeURIComponent(masterKey)}`
    : `${API_BASE}/api/documents/${documentId}`;
  const res = await fetch(url, {
    headers: { ...(token && !masterKey ? { Authorization: `Bearer ${token}` } : {}) },
  });
  if (!res.ok) {
    return;
  }
  const data = (await res.json()) as { projectId?: string };
  dispatchMentionableEntitiesChanged(data.projectId);
}
